"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgToolboxFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M26 8V4l-.59-.27A24.5 24.5 0 0016 2a24.56 24.56 0 00-9.4 1.68L6 4v4H2v6h28V8zM8 5.28A24.49 24.49 0 0116 4a24.43 24.43 0 018 1.28V8H8zM28 16.01H16.99v3.01h-2v-3.01H2v11h28v-11h-2z" })));
}
exports.default = SvgToolboxFilled;
//# sourceMappingURL=ToolboxFilled.js.map